import React from 'react';
import ToggleOff from '@mui/icons-material/ToggleOffOutlined';
import ToggleOn from '@mui/icons-material/ToggleOn';

const toggleStyle = { color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' };

const WidgetCommonToggleSettings = ({
  edit,
  setEdit,
  t,
  showUnitWidgetTypes,
  isWaterNetworkWidgetType,
}) => (
  <>
    {showUnitWidgetTypes.includes(edit.type) ? (
      <div className="form-item">
        <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
          {t.settingsLabels?.showUnit || "Show Unit"}
        </label>
        {edit.props.showUnit !== false ? (
          <ToggleOn
            style={toggleStyle}
            onClick={() => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, showUnit: false }
            }))}
          />
        ) : (
          <ToggleOff
            style={toggleStyle}
            onClick={() => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, showUnit: true }
            }))}
          />
        )}
      </div>
    ) : null}

    {isWaterNetworkWidgetType(edit.type) ? (
      <div className="form-item">
        <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
          {t.settingsLabels?.linkToNearby || 'Link To Nearby Water Widgets'}
        </label>
        {edit.props.linkToNearby !== false ? (
          <ToggleOn
            style={toggleStyle}
            onClick={() => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, linkToNearby: false }
            }))}
          />
        ) : (
          <ToggleOff
            style={toggleStyle}
            onClick={() => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, linkToNearby: true }
            }))}
          />
        )}
      </div>
    ) : null}
  </>
);

export default WidgetCommonToggleSettings;
